<template>
  <div class="hello">
    <font-awesome-icon
      v-if="!loading && success"
      icon="fa-solid fa-circle-check"
      class="icon-success"
    />
    <font-awesome-icon
      v-if="!loading && !success"
      icon="fa-solid fa-circle-xmark"
      class="icon"
    />
    <h1>{{ $t("message.title") }}</h1>
    <p v-if="loading">{{ $t("message.verifying") }}</p>
    <p v-if="!loading && success">
      {{ $t("message.success") }}
    </p>
    <p v-if="!loading && !success">
      {{ errorMessage }}
      <!-- {{ $t("message.error", { errorMessage: errorMessage }) }} -->
      <!-- There was an error verifying your email: {{ errorMessage }} -->
    </p>
    <button class="button" @click="goBackToEshop">
      {{ $t("backToEshop") }}
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { useI18n } from "vue-i18n";
export default {
  name: "EmailLanding",
  data() {
    return {
      loading: true,
      success: false,
      errorMessage: "",
    };
  },
  mounted() {
    const { locale } = useI18n();
    let urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get("lang");
    if (lang) {
      locale.value = lang;
      document.title = this.$t("pageTitle");
    }
    if (urlParams.has("verification")) {
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/v1/member/email/verify`, {
          verificationToken: urlParams.get("verification"),
        })
        .then((response) => {
          console.log(">>>>>>>>>response", response?.data);
          this.success = true;
        })
        .catch((error) => {
          if (error?.response?.data?.code === 17) {
            this.errorMessage = this.$t("error.alreadyVerified");
          }
          if (
            error?.response?.data?.code === 16 ||
            error?.response?.data?.code === 18 ||
            error?.response?.data?.code === 314
          ) {
            this.errorMessage = this.$t("error.expiredCode");
          }
          // this.errorMessage = error.response.data.message;
          this.success = false;
        })
        .finally(() => (this.loading = false));
    } else {
      this.loading = false;
      this.success = false;
      this.errorMessage = "Verification token not found.";
    }
  },
  methods: {
    goBackToEshop() {
      window.location.href = 'https://www.mira-eshop.com/'; // Change this to your desired URL
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.icon {
  font-size: 48px;
  color: #d71920;
}
.icon-success {
  font-size: 48px;
  color: #42b983;
}
.button {
  background-color: #c49853;
  padding: 10px 20px;
  border-width: 0px;
  font-size: 14px;
  font-family: "FuturaBookBT";
  color: #fff;
  min-width: 140px;
  min-height: 41px;
}
</style>
